<template>
  <div class="form-page">
    <div class="form-page__header">
      <h2 class="form-page__title">Zusammenfassung &amp; Bestätigung</h2>
      <p class="form-page__subtitle">Bitte prüfen Sie Ihre Angaben vor dem Absenden.</p>
    </div>

    <div class="info-box info-box--green" style="margin-bottom: 24px;">
      <span class="info-box__icon">✅</span>
      <div>
        <strong>Antrag vollständig ausgefüllt</strong>
        <p>Alle Pflichtfelder wurden erfasst. Sie können den Antrag jetzt absenden.</p>
      </div>
    </div>

    <!-- AutoFill badge if data was auto-filled -->
    <div v-if="hasAutofill" class="info-box info-box--blue" style="margin-bottom: 24px;">
      <span class="info-box__icon">✦</span>
      <div>
        <strong>AutoFill aktiv</strong>
        <p>Die blau markierten Felder wurden automatisch aus Ihrem Dokument ausgelesen.</p>
      </div>
    </div>

    <!-- Section: Antragstellung -->
    <div class="summary-section">
      <div class="summary-section__title">Art der Antragstellung</div>
      <div class="summary-row">
        <span class="summary-row__label">Antragstellungsart</span>
        <span class="summary-row__value">
          {{ modelValue.antragstellungsart === 'eigenantrag' ? 'Eigenantrag' : modelValue.antragstellungsart === 'vertretung' ? 'Rechtliche Vertretung' : '–' }}
        </span>
      </div>
    </div>

    <!-- Section: Persönliche Daten -->
    <div class="summary-section">
      <div class="summary-section__title">Persönliche Daten</div>
      <div class="summary-row">
        <span class="summary-row__label">Anrede</span>
        <span class="summary-row__value" :class="{ autofilled: modelValue._autofilled?.anrede }">
          {{ modelValue.anrede || '–' }}
          <span v-if="modelValue._autofilled?.anrede" class="badge badge--blue" style="margin-left:6px">AutoFill</span>
        </span>
      </div>
      <div class="summary-row" v-if="modelValue.titel">
        <span class="summary-row__label">Titel</span>
        <span class="summary-row__value">{{ modelValue.titel }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Vorname</span>
        <span class="summary-row__value" :class="{ autofilled: modelValue._autofilled?.vorname }">
          {{ modelValue.vorname || '–' }}
          <span v-if="modelValue._autofilled?.vorname" class="badge badge--blue" style="margin-left:6px">AutoFill</span>
        </span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Nachname</span>
        <span class="summary-row__value" :class="{ autofilled: modelValue._autofilled?.nachname }">
          {{ modelValue.nachname || '–' }}
          <span v-if="modelValue._autofilled?.nachname" class="badge badge--blue" style="margin-left:6px">AutoFill</span>
        </span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Geburtsdatum</span>
        <span class="summary-row__value" :class="{ autofilled: modelValue._autofilled?.geburtsdatum }">
          {{ formatDate(modelValue.geburtsdatum) }}
          <span v-if="modelValue._autofilled?.geburtsdatum" class="badge badge--blue" style="margin-left:6px">AutoFill</span>
        </span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Geburtsort</span>
        <span class="summary-row__value" :class="{ autofilled: modelValue._autofilled?.geburtsort }">
          {{ modelValue.geburtsort || '–' }}
          <span v-if="modelValue._autofilled?.geburtsort" class="badge badge--blue" style="margin-left:6px">AutoFill</span>
        </span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Staatsangehörigkeit</span>
        <span class="summary-row__value" :class="{ autofilled: modelValue._autofilled?.staatsangehoerigkeit }">
          {{ modelValue.staatsangehoerigkeit || '–' }}
          <span v-if="modelValue._autofilled?.staatsangehoerigkeit" class="badge badge--blue" style="margin-left:6px">AutoFill</span>
        </span>
      </div>
    </div>

    <!-- Section: Kontakt -->
    <div class="summary-section">
      <div class="summary-section__title">Kontaktdaten</div>
      <div class="summary-row">
        <span class="summary-row__label">E-Mail</span>
        <span class="summary-row__value" :class="{ autofilled: modelValue._autofilled?.email }">
          {{ modelValue.email || '–' }}
          <span v-if="modelValue._autofilled?.email" class="badge badge--blue" style="margin-left:6px">AutoFill</span>
        </span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Mobiltelefon</span>
        <span class="summary-row__value" :class="{ autofilled: modelValue._autofilled?.mobil }">
          {{ modelValue.mobil || '–' }}
          <span v-if="modelValue._autofilled?.mobil" class="badge badge--blue" style="margin-left:6px">AutoFill</span>
        </span>
      </div>
    </div>

    <div class="info-box info-box--yellow" style="margin-top: 8px;">
      <span class="info-box__icon">ℹ️</span>
      <div>
        <strong>Showcase-Hinweis</strong>
        <p>Dies ist eine Demo-Umgebung. Es werden keine echten Daten übermittelt.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'NatStep3',
  props: {
    modelValue: { type: Object, required: true },
    showErrors: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props) {
    const hasAutofill = computed(() => props.modelValue._autofilled && Object.keys(props.modelValue._autofilled).length > 0);
    const formatDate = (val) => {
      if (!val) return '–';
      const d = new Date(val);
      if (isNaN(d)) return val;
      return d.toLocaleDateString('de-DE');
    };
    return { hasAutofill, formatDate };
  },
};
</script>

<style scoped src="../form.css"></style>
